import { v4 } from 'uuid';

import { RecordData } from '../../helpers-classes';
import { PanelItemData, PanelItemDataIn } from './types';

import { DIMENSION_INSIDE_LINE_FACTOR_X, DIMENSION_INSIDE_LINE_FACTOR_Y, DIMENSION_INSIDE_TEXT_POSITION_FACTOR_X, DIMENSION_INSIDE_TEXT_POSITION_FACTOR_Y } from '../dimensions/constants';

export const panelItemData = (dataIn: PanelItemDataIn = null): PanelItemData => {
	const rd = new RecordData<PanelItemDataIn>(dataIn);

	// const item = new Item({ dataIn: dataIn?.item ?? null });
	// const boundToEdge = rd.data?.boundToEdge > 0
	// 	? rd.data.boundToEdge
	// 	: [COMPONENT_PLACEMENT_FRONT_AND_TOP, COMPONENT_PLACEMENT_TOP_ONLY].indexOf(item.placement) > -1
	// 		? BoundToEdge.Top
	// 		: [COMPONENT_PLACEMENT_BOTTOM_ONLY].indexOf(item.placement) > -1
	// 			? BoundToEdge.Bottom
	// 			: BoundToEdge.No;

	const record: PanelItemData = {
		id: rd.useNewOrPartial<string>('id', v4()),
		// description: rd.useNewOrDefault<string>('description', null),
		// boundToEdge: rd.useNewOrDefault<number>('boundToEdge', boundToEdge),
		boundToEdge: rd.useNewOrDefault<number>('boundToEdge', null),
		fullHeight: rd.useNewOrDefault<boolean>('fullHeight', false),
		ruleManaged: rd.useNewOrDefault<boolean>('ruleManaged', true),
		dimensionOffsets: {
			vLine: DIMENSION_INSIDE_LINE_FACTOR_X,
			vLabel: DIMENSION_INSIDE_TEXT_POSITION_FACTOR_X,
			hLine: DIMENSION_INSIDE_LINE_FACTOR_Y,
			hLabel: DIMENSION_INSIDE_TEXT_POSITION_FACTOR_Y,
			zLine: DIMENSION_INSIDE_LINE_FACTOR_Y,
			zLabel: DIMENSION_INSIDE_TEXT_POSITION_FACTOR_Y,
			...(dataIn?.dimensionOffsets ?? {})
		},
		// item: item.serialize(),
		item: dataIn?.item ?? {},
		sleeve: rd.useNewOrDefault<string>('sleeve', null),
		// vendor: rd.useNewOrDefault<string>('vendor', ''),
		sidePadding: rd.useNewOrDefault<number>('sidePadding', 0),
		offset: {
			x: 0,
			y: 0,
			z: 0,
			...(dataIn?.offset ?? {})
		},
		center: {
			x: 0,
			y: 0,
			z: 0,
			...(dataIn?.center ?? {})
		},
		instanceRotation: {
			x: 0,
			y: 0,
			z: 0,
			...(dataIn?.instanceRotation ?? {})
		}
	}

	return record;
};
